import React from "react"
import {ReadCommitResult} from "isomorphic-git"
import {useNavigate} from "react-router-dom"
import {faCircleUser} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {getTimeFromNow} from "../../../functions/time"
import styles from "./index.module.scss"

interface CommitsStatusProps {
  commits: ReadCommitResult[]
  href?: string
}

export const CommitsStatus = (props: CommitsStatusProps) => {
  const navigate = useNavigate()
  const totalCommitsMade = props.commits.length
  if (totalCommitsMade <= 0) {return <></>}
  
  const commits = props.commits.sort((a, b) => b.commit.committer.timestamp - a.commit.committer.timestamp)
  const lastCommit = commits[totalCommitsMade - 1]
  const {
    name: lastCommitName, timestamp: lastCommitTime
  } = lastCommit.commit.committer

  const onClick = () => props.href && navigate(props.href)
  const className = props.href && "cursor-pointer"
  
  return (
    <div className={styles.Container}>
      <div className={styles.FirstRow}>
        <FontAwesomeIcon icon={faCircleUser}/>
        <p>{lastCommitName} - {getTimeFromNow(lastCommitTime)}</p>
      </div>
      <p>
        Total - <u onClick={onClick} className={className}>{totalCommitsMade}</u> commits</p>
    </div>
  )
}